import { requestTool } from "../tools";
const CONTROLLER_URL = "/api/user/GetUserByToken";
const login = (data) =>
    requestTool.postRequest(process.env.REACT_APP_API_URL + "/api/token",
        {
            "username": data.username,
            "password": data.password,
            "googleCredential": data.credential,
            "googleClientId" : data.clientId
        });

const getUserByToken = (url) => requestTool.getRequest(url + CONTROLLER_URL);

export const authenticationService = { login, getUserByToken };

export default authenticationService;

